import React from 'react';
import { cd } from "../../utils/cd";
import {MessageStatus, MessageStatusHint} from "./constans";
import {Attachment} from "../Attachment/Attachment";
import {Hint} from "../Hint";

function formatText(txt) {
    if(!txt) return null;
    return txt.replace(/\\n/g, "\n").replace(/\n/g, "<br />").replace(/(https?:\/\/[^\s]+)/g, function(url) {
        return '<a href="' + url + '">' + url + '</a>';
    });
}

function getMonthFormatRu(month){
    switch (month){
        case 0: return 'янв';
        case 1: return 'фев';
        case 2: return 'мар';
        case 3: return 'апр';
        case 4: return 'мая';
        case 5: return 'июн';
        case 6: return 'июл';
        case 7: return 'авг';
        case 8: return 'сен';
        case 9: return 'окт';
        case 10: return 'ноя';
        case 11: return 'дек';
        default: return '';
    }
}

function getMonthFormatEn(month){
    switch (month){
        case 0: return 'jan';
        case 1: return 'feb';
        case 2: return 'mar';
        case 3: return 'apr';
        case 4: return 'may';
        case 5: return 'jun';
        case 6: return 'jul';
        case 7: return 'aug';
        case 8: return 'sep';
        case 9: return 'oct';
        case 10: return 'nov';
        case 11: return 'dec';
        default: return '';
    }
}

function formatDateIO(date){
    if(date < 10){
        return '0'+date;
    }
    return date;
}

function getMonthFormat(month){
    const params = new URLSearchParams(window.location.search);
    const lang = params.get("lang");

    if(lang === 'ru'){
        return getMonthFormatRu(month);
    }else{
        return getMonthFormatEn(month);
    }
}

function formatDate(datetimeString){
    const dateTimeClean = datetimeString.split(' ');
    let dateTime = dateTimeClean[0] + 'Z';
    if(dateTimeClean[1] !== 'UTC'){
        dateTime = dateTimeClean[0];
    }
    const date = new Date(dateTime);

    const nowDate = new Date();

    const isToday = date.getDate() === nowDate.getDate() && date.getMonth() === nowDate.getMonth() && date.getFullYear() === nowDate.getFullYear();

    if(isToday){
        return formatDateIO(date.getHours())+':'+formatDateIO(date.getMinutes());
    }
    return date.getDate() + " " +getMonthFormat(date.getMonth()) +" "+ formatDateIO(date.getHours())+':'+formatDateIO(date.getMinutes());

}

export const Message = ({text, status, datetime, type, attachments}) => {
    const Icon = MessageStatus[status];
    const hint = MessageStatusHint[status];
    if(!type){
        return null;
    }

    return(<div className={"chat-item "+ cd({
        "chat-item-mes-from": type === 'from_client',
        "chat-item-mes-to": type === 'to_client',
        "chat-item-mes-sys": type === 'system',
        "chat-item-mes-com": type === 'comment'
    })}>
        <div className={"chat-message " + cd({
            "chat-message-from": type === 'from_client',
            "chat-message-to": type === 'to_client',
            "chat-message-sys": type === 'system',
            "chat-message-com": type === 'comment'
        })}>
            <div className="chat-body" dangerouslySetInnerHTML={{__html: formatText(text)}}/>
            <div className={"chat-attach" + cd({
                "chat-attach-empty-body": !text
            })}>
                { attachments.map((attach) => <Attachment key={attach.link} id={attach.link} link={attach.link} name={attach.name} />) }
            </div>
            <div className="chat-status">
                <div className="chat-status-date">{formatDate(datetime)}</div>
                <div className="chat-status-status"><Hint type={hint?.type} message={hint?.text}>{Icon}</Hint></div>
            </div>
        </div>
    </div>)
}